import { PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'src/store/app/types';

const showBackdropReducer = (state: AppState, action: PayloadAction<boolean>) => {
  state.isBackdropVisible = action.payload;
};

export default showBackdropReducer;
